import { Routes } from '@angular/router';
import { DashboardOrgao } from './dashboard-orgao/dashboard-orgao';
import { OrgaoContent } from './orgao-content';
import { orgaoRelatoriosRoutes } from '@/features/registro/orgaos/relatorios/orgao-relatorios.routes';
import { DelegaciaDetalhe } from './dashboard-orgao/components/delegacias/delegacia-detalhe';
import { ORGAO_ROUTES } from './orgao.constants';
import { permissionGuard } from '@/core/permissions/permission.guard';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';

/**
 * Rotas do módulo Órgão (segmentos em `ORGAO_ROUTES` — ver `orgao.constants.ts`):
 * - `/orgao` → shell `OrgaoContent`; rota padrão renderiza o `DashboardOrgao`;
 * - `/orgao/delegacia/:id/:uf` → detalhe da delegacia;
 * - `/orgao/relatorios/*` → relatórios do módulo.
 */
export const orgaoRoutes: Routes = [
    {
        path: ORGAO_ROUTES.ROOT,
        component: OrgaoContent,
        canActivate: [permissionGuard],
        data: { breadcrumb: 'Órgão', permission: PERMISSOES.orgaos.modulo },
        children: [
            { path: ORGAO_ROUTES.DASHBOARD, component: DashboardOrgao },
            { path: `${ORGAO_ROUTES.DELEGACIA}/:id/:uf`, component: DelegaciaDetalhe, canActivate: [permissionGuard], data: { breadcrumb: 'Delegacia', permission: PERMISSOES.orgaos.delegacias.escopo } },
            ...orgaoRelatoriosRoutes
        ]
    }
];
